<template>
	<div>
		<div class="main flex_center" :style="mainBg">
			<div class="contentBox flex_center">
				<div>
					<div class="loginTitleRow flex_center">
						<img src="../../assets/logo.png" alt="" class="loginLogo" />
						<div class="title">聚合SDK管理系统</div>
					</div>
					<div class="loginTips">账号密码</div>
					<div class="loginInput">
						<el-input size="medium" placeholder="账号" v-model="accountNumber" clearable></el-input>
					</div>
					<div class="loginInput">
						<el-input size="medium" type="password" placeholder="密码" v-model="password" @keyup.enter.native="login()" clearable>
						</el-input>
					</div>
					<div class="save_pwd">
						<el-checkbox v-model="savePwd">记住密码</el-checkbox>
					</div>
					<!-- 验证码 -->
					<!-- <div class="space_between">
						<div class="codeInput">
							<el-input size="medium" placeholder="请输入验证码" v-model="code" clearable>
							</el-input>
						</div>
						<div class="codeImg" @click="refreshCode">
							<s-Identify :identifyCode="identifyCode"></s-Identify>
						</div>
					</div> -->
					<div class="loginBtn" @click="login">登录</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Sidentify from '../../components/graphicVerifi.vue';
	export default {
		components: {
			's-Identify': Sidentify
		},
		data() {
			return {
				accountNumber: '',
				password: '',
				code: '',
				identifyCode: '1234',
				// 验证码规则
				identifyCodes: '1234567890',
				mainBg:{backgroundImage:'url(' + require('../../assets/login/loginbgs.png') + ')',},
				savePwd:false,//记住密码
				// mainBg:{backgroundImage:'url(https://pujf.oss-cn-hangzhou.aliyuncs.com/puhuaSystemImage/assets/img/loginBg.png)',},
				// mainBg:{backgroundImage:'url(../../assets/img/loginBg.png)',},
			}
		},
		mounted(){
			let isSave = localStorage.getItem("isSaves");
			if(isSave==1){
				this.savePwd = true
				this.accountNumber = localStorage.getItem("accountNumbers");
				this.password = localStorage.getItem("passwords");
			}
		},
		methods: {
			// 切换验证码
			refreshCode() {
				this.identifyCode = ''
				this.makeCode(this.identifyCodes, 4)
			},
			// 生成随机验证码
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						Math.floor(Math.random() * (this.identifyCodes.length - 0) + 0)
					]
				}
			},
			//点击登录
			async login(){
				if(!this.accountNumber){
					this.$message.warning('请输入账号')
					return
				}
				if(!this.password){
					this.$message.warning('请输入密码')
					return
				}
				// if(this.code!=this.identifyCode){
				// 	this.$message({
				// 		type:'warning',
				// 		message:'请输入正确的验证码'
				// 	})
				// 	return
				// }
				let data = {
					userType: 0,
					username: this.accountNumber,
					password: this.password,
				}
				let res = await this.$http.post(this.$api.adminLogin, data);
				console.log(res)
				if(res.code == 1){
					sessionStorage.removeItem('token-sdk-system')
					sessionStorage.setItem('token-sdk-system',res.data.token)
					//记住密码
					if(this.savePwd){
						localStorage.setItem('isSaves',1)
						localStorage.setItem('accountNumbers',this.accountNumber)
						localStorage.setItem('passwords',this.password)
					}else{
						localStorage.removeItem('isSaves')
						localStorage.removeItem('accountNumbers')
						localStorage.removeItem('passwords')
					}
					sessionStorage.setItem('sdk-userinfo',JSON.stringify(res.data))
					await this.getUserInfo();
					this.getRouters();
					// this.$router.replace({
					// 	path: '/'
					// })
				}
			},
			// 获取用户信息
			async getUserInfo(){
				let res = await this.$http.get(this.$api.userManage.getInfo);
				if(res.code==1){
					if(res.data.permissions&&res.data.permissions.length>0)
					this.$store.commit('changePermissions', res.data.permissions);
					sessionStorage.removeItem('sdk-permissions');
					sessionStorage.setItem('sdk-permissions',JSON.stringify(res.data.permissions));
					sessionStorage.removeItem('sdk-roles');
					sessionStorage.setItem('sdk-roles',JSON.stringify(res.data.roles));
					// 缓存角色类型，报表页用于判断是否为媒介角色
					sessionStorage.removeItem('sdk-roleType');
					sessionStorage.setItem('sdk-roleType',JSON.stringify(res.data.user && res.data.user.roleType ? res.data.user.roleType : []));
				}
				// console.log(res)
			},
			// 获取路由信息
			async getRouters(){
				let res = await this.$http.get(this.$api.userManage.getRouters);
				if(res.code !==1 ) return
				if(res.data&&res.data.length>0){
					this.$store.commit('changeNavList', JSON.parse(JSON.stringify(res.data)));
					localStorage.removeItem('sdk-navList');
					localStorage.setItem('sdk-navList',JSON.stringify(res.data));
					// return
					// 接收处理后的路由
					let flattenedRoutes = await this.flattenRoutes(JSON.parse(JSON.stringify(res.data)));
					// setTimeout(()=>{
					// 	console.log(filteredRoutes)
					// },1000)
					let filteredRoutes = this.filterRouter(JSON.parse(JSON.stringify(flattenedRoutes)));
					// let dynamicRoutes = [
					// 	{
					// 		path: 'personal', 
					// 		name: 'personal',
					// 		component: () =>
					// 			import( /* webpackChunkName: "personal" */ '../views/personal/personalCenter.vue'),
					// 		meta: {
					// 			title: '个人信息'
					// 		}
					// 	},
					// 	{
					// 		path: 'Loan/Loan/index',
					// 		name: 'Loan/Loan/index',
					// 		component: () =>
					// 			import( /* webpackChunkName: "followTypeAdmin" */ '../views/personal/personalInfo.vue'),
					// 		meta: {
					// 			title: '账号信息'
					// 		}
					// 	},
					// 	{
					// 		path: 'Loan/Loan/updatepwd',
					// 		name: 'Loan/Loan/updatepwd',
					// 		component: () =>
					// 			import( /* webpackChunkName: "followTypeAdmin" */ '../views/personal/resetPwd.vue'),
					// 		meta: {
					// 			title: '修改密码'
					// 		}
					// 	},
					// ]
					// , ...dynamicRoutes
					// 合并新旧 children
					const mergedChildren = [...filteredRoutes];
					// mergedChildren[0].path = ''
					console.log(mergedChildren)
					// let routes = [
					// 	{
					// 		path: '/',
					// 		name: 'index',
					// 		component: () => import('../views/index.vue'),
					// 		children: mergedChildren
					// 	}
					// ]
					// router.addRoutes(routes) // 动态添加路由配置到现有路由表中
					let paths = '/' + mergedChildren[0].path
					console.log(paths)
					localStorage.removeItem('sdk-visitedViews');
					localStorage.removeItem('sdk-routes');
					localStorage.setItem('sdk-routes',JSON.stringify(mergedChildren));
					this.$router.replace(paths);
					// console.log('扁平化后的路由:', mergedChildren);
				}else{
					let res = await this.$http.get(this.$api.userManage.loginout);
					if(res.code==1){
						sessionStorage.clear();
						this.$message.warning('无权限，请联系管理员添加权限！')
					}
				}
			},
			filterRouter(arr) {
			  // 处理每个路由项并返回新数组
			  return arr.map((item) => {
			    // console.log(item.path);
			    if (item.path) {
			      item.component = this.loadView(item.path);
						// // 调试：打印路径和 component 函数（可选）
						// console.log(`Route: ${item.path}`, item.component);
			    }
			    // if (item.children && item.children.length > 0) {
			    //   // 递归处理子路由
			    //   item.children = this.filterRouter(item.children);
			    // }
			    return item;
			  });
			},
			// 扁平化路由（修正版）
			flattenRoutes(routes) {
			  return routes.reduce((flattened, route) => {
			    if (route.path) {
			      const { children, ...rest } = route;
			      const normalizedPath = route.path.startsWith('/') ? route.path.slice(1) : route.path;
			      flattened.push({ ...rest, path: normalizedPath });
			    }
			    if (route.children?.length) {
			      flattened.push(...this.flattenRoutes(route.children));
			    }
			    return flattened;
			  }, []);
			},
			// 组建页面路径
			loadView(view){
				return () => import(`../../views/${view}.vue`)
			},
		}
	}
</script>

<style type="text/css">
	.loginInput .el-input__inner{
		height: 40px;
		line-height: 40px;
	}
	/* .codeInput .el-input__inner{
		background: hsla(0,0%,100%,.2);
		border: 1px solid #00c0ff;
		color: #fff;
	} */
	/* .loginInput .el-select-dropdown{
		background-color: rgba(255, 255, 255, .1) !important;
	} */
</style>
<style scoped>
	.main {
		width: 100%;
		margin: 0 auto;
		height: 100vh;
		background-size: cover;
		background-repeat: no-repeat;
		align-items: center;
	}

	.leftImg {
		width: 540px;
		height: 100%;
		align-items: center;
	}

	.leftImg img {
		width: 540px;
		height: 464px;
	}

	.contentBox {
		/* height: 470px;
		width: 20%; */
		align-items: center;
		margin: 0 auto;
		color: #646464;
		/* background-image: url(../../assets/login/loginboxBg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat; */
		background: #ffffff;
		box-sizing: border-box;
		padding: 60px 50px;
	}
	.loginTitleRow{
		align-items: center;
		margin-bottom: 32px;
	}
	.loginLogo{
		width: 40px;
		height: 40px;
	}

	.logoImg {
		width: 60px;
		height: 50px;
		margin-right: 15px;
	}

	.title {
		text-align: center;
		font-weight: 600;
		font-size: 22px;
		color: #000000;
		margin-left: 4px;
	}
	.loginTips{
		font-weight: 600;
		font-size: 16px;
		color: #333333;
		margin-bottom: 24px;
	}

	.comeInText {
		font-size: 18px;
		line-height: 60px;
	}

	.loginInput {
		width: 286px;
		margin-bottom: 16px;
	}

	.codeInput {
		width: 238px;
		margin-bottom: 25px;
	}

	.loginBtn {
		width: 286px;
		height: 48px;
		/* background: linear-gradient(0deg,#0060ff,#0096ff); */
		background: #007FFF;
		border-radius: 4px;
		font-size: 18px;
		line-height: 48px;
		text-align: center;
		color: #FFFFFF;
		cursor: pointer;
		margin-top: 30px;
	}
	.codeImg{
		cursor: pointer;
		margin-top: -4px;
	}
	
	.save_pwd /deep/ .el-checkbox{
		color: #333;
		margin-left: 2px;
	}

	img {
		width: 100%;
		height: 100%;
	}
</style>
